(() => {
  "use strict";

  const stickyOffset = () => (window.matchMedia("(max-width: 760px)").matches ? 74 : 92);

  function revealPath(pathName, options = {}) {
    const { scroll = true } = options;
    const buttons = [...document.querySelectorAll("[data-path]")];
    const panels = [...document.querySelectorAll(".task-path")];
    const activePanel = document.getElementById(`path-${pathName}`);
    if (!activePanel) return;

    buttons.forEach((button) => {
      const selected = button.dataset.path === pathName;
      button.classList.toggle("is-selected", selected);
      button.setAttribute("aria-expanded", String(selected));
    });
    panels.forEach((panel) => { panel.hidden = panel !== activePanel; });

    if (scroll) {
      const top = activePanel.getBoundingClientRect().top + window.scrollY - stickyOffset();
      window.scrollTo({ top, behavior: "smooth" });
      window.setTimeout(() => activePanel.focus({ preventScroll: true }), 350);
    }
  }

  document.querySelectorAll("[data-path]").forEach((button) => {
    button.addEventListener("click", () => revealPath(button.dataset.path));
  });

  const osTabs = [...document.querySelectorAll("[data-os]")];
  const osPanels = [...document.querySelectorAll(".os-panel")];
  function selectOs(osName, focus = false) {
    osTabs.forEach((tab) => {
      const selected = tab.dataset.os === osName;
      tab.setAttribute("aria-selected", String(selected));
      tab.tabIndex = selected ? 0 : -1;
      if (selected && focus) tab.focus();
    });
    osPanels.forEach((panel) => { panel.hidden = panel.id !== `${osName}-steps`; });
  }
  osTabs.forEach((tab, index) => {
    tab.addEventListener("click", () => selectOs(tab.dataset.os));
    tab.addEventListener("keydown", (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let next = index;
      if (event.key === 'ArrowLeft') next = (index - 1 + osTabs.length) % osTabs.length;
      if (event.key === 'ArrowRight') next = (index + 1) % osTabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = osTabs.length - 1;
      selectOs(osTabs[next].dataset.os, true);
    });
  });

  const setupLightbox = document.getElementById("setupImageLightbox");
  const setupLightboxImage = setupLightbox?.querySelector("img");
  const setupLightboxStage = setupLightbox?.querySelector(".setup-lightbox-stage");
  const setupLightboxCaption = document.getElementById("setupLightboxCaption");
  const setupLightboxClose = setupLightbox?.querySelector(".setup-lightbox-close");
  let setupLightboxTrigger = null;

  function closeSetupLightbox() {
    if (!setupLightbox?.open) return;
    setupLightbox.close();
  }

  document.querySelectorAll("[data-lightbox-src]").forEach((button) => {
    button.addEventListener("click", () => {
      if (!setupLightbox || !setupLightboxImage) return;
      setupLightboxTrigger = button;
      setupLightboxImage.src = button.dataset.lightboxSrc;
      setupLightboxImage.alt = button.dataset.lightboxAlt || "Enlarged setup screenshot";
      if (setupLightboxStage) setupLightboxStage.dataset.annotation = button.dataset.annotation || "";
      if (setupLightboxCaption) setupLightboxCaption.textContent = button.dataset.lightboxCaption || "";
      document.documentElement.classList.add("setup-lightbox-open");
      setupLightbox.showModal();
      window.setTimeout(() => setupLightboxClose?.focus(), 20);
    });
  });
  setupLightboxClose?.addEventListener("click", closeSetupLightbox);
  setupLightbox?.addEventListener("click", (event) => {
    if (event.target === setupLightbox) closeSetupLightbox();
  });
  setupLightbox?.addEventListener("close", () => {
    document.documentElement.classList.remove("setup-lightbox-open");
    setupLightboxTrigger?.focus();
  });

  document.querySelectorAll(".step-next").forEach((link) => {
    link.addEventListener("click", (event) => {
      const selector = link.getAttribute("href");
      const target = selector?.startsWith("#") ? document.querySelector(selector) : null;
      if (!target) return;
      event.preventDefault();
      window.history.pushState(null, "", selector);
      const top = target.getBoundingClientRect().top + window.scrollY - stickyOffset();
      window.scrollTo({ top, behavior: "smooth" });
      window.setTimeout(() => target.focus({ preventScroll: true }), 350);
    });
  });

  const menuButton = document.getElementById("guideMenuButton");
  const menu = document.getElementById("guideMenu");
  const menuPanel = document.getElementById("guideMenuPanel");
  const menuClose = menu?.querySelector(".guide-menu-close");
  const menuBackdrop = menu?.querySelector(".guide-menu-backdrop");
  let menuLastFocus = null;

  const focusable = (root) => [...root.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter((element) => !element.hidden && element.offsetParent !== null);

  function closeMenu(restoreFocus = true) {
    if (!menu) return;
    menu.classList.remove("is-open");
    menu.setAttribute("aria-hidden", "true");
    menuButton?.setAttribute("aria-expanded", "false");
    document.documentElement.classList.remove("guide-menu-open");
    if (restoreFocus && menuLastFocus instanceof HTMLElement) menuLastFocus.focus();
  }

  function openMenu() {
    if (!menu || !menuPanel) return;
    menuLastFocus = document.activeElement;
    menu.classList.add("is-open");
    menu.setAttribute("aria-hidden", "false");
    menuButton?.setAttribute("aria-expanded", "true");
    document.documentElement.classList.add("guide-menu-open");
    window.setTimeout(() => menuClose?.focus(), 30);
  }

  menuButton?.addEventListener("click", openMenu);
  menuClose?.addEventListener("click", () => closeMenu(true));
  menuBackdrop?.addEventListener("click", () => closeMenu(true));
  menu?.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      const path = link.dataset.openPath;
      if (path) revealPath(path, { scroll: false });
      closeMenu(false);
    });
  });

  document.addEventListener("keydown", (event) => {
    if (!menu?.classList.contains("is-open")) return;
    if (event.key === "Escape") {
      event.preventDefault();
      closeMenu(true);
      return;
    }
    if (event.key !== "Tab" || !menuPanel) return;
    const items = focusable(menuPanel);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  const transcyMount = document.getElementById("iug-language-switcher");
  if (transcyMount) {
    let transcyObserver;
    let transcyTimer;
    const attachSwitcher = () => {
      const button = document.getElementById("transcyBtnSwitcher");
      const switcher = button?.closest(".transcy-switcher-manual");
      if (!switcher || transcyMount.contains(switcher)) return Boolean(switcher);
      const desktopMount = transcyMount.querySelector(".transcy-switcher-manual.transcy-desktop");
      desktopMount?.replaceWith(switcher);
      switcher.classList.remove("transcy-mobile");
      switcher.classList.add("transcy-desktop");
      transcyMount.querySelectorAll(".transcy-switcher-manual").forEach((node) => {
        if (node !== switcher && !node.children.length) node.remove();
      });
      transcyObserver?.disconnect();
      window.clearInterval(transcyTimer);
      return true;
    };
    if (!attachSwitcher()) {
      transcyObserver = new MutationObserver(attachSwitcher);
      transcyObserver.observe(document.documentElement, { childList: true, subtree: true });
      transcyTimer = window.setInterval(attachSwitcher, 500);
      window.setTimeout(() => {
        transcyObserver?.disconnect();
        window.clearInterval(transcyTimer);
      }, 15000);
    }
  }

})();
